
import "./Loader.css"

const LoadingGif = () => {
   return ( 
      <section className="dots-container">
         <div className="dot"></div>
         <div className="dot"></div>
         <div className="dot"></div>
         <div className="dot"></div>
         <div className="dot"></div>
      </section>

   )
};
export default LoadingGif;